import Joi from '@hapi/joi'

export const factorySchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name characters`
    }),
    operationEntityCode: Joi.string().invalid("00").required().min(2).max(2).label("Factory Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Factory Code required`,
        "string.pattern.base": `Factory Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`,
        "any.invalid": `Cannot have 00 as factory code`
    }),
    operationEntityName: Joi.string().required().label("Factory Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Factory Name required`,
        "string.pattern.base": `Please enter valid factory name`,
    }),
    operationEntityLocation: Joi.string().allow("", null).label("Location Name"),
    isActive: Joi.boolean().label("Active"),
    isErpEnabled: Joi.boolean().label("Is ERP Enabled")
}